import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import { LoaderMi, Button, Row, ButtonGroup, Col } from '@design-system-etat/dsfr-react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import { getDateFRFromYYYYMMDDHHMMSS } from 'components/Commun/Form/Date/dateTranformation';
import {
    API_CEAF_GENERATION_PDF,
    API_CEAF_VISUALISER,
    CONTEXT_API_CEAF_VISUALISER,
    CONTEXT_CEAF_GENERATION_PDF,
} from '../../../../../constants/apiUrls.constants';
import usagerClientReducer from '../../../../../store/usagerReducer';
import InformationsPersonnelles from '../../../../../components/Ceaf/InformationsPersonnelles/InformationsPersonnelles';
import InformationAdresse from '../../../../../components/adresse/InformationsAdresse';
import VisualiserPhotoIdentite from '../../../../../components/PhotoIdentite/Visualiser/VisualiserPhotoIdentite';
import styles from './VisualiserCeaf.module.scss';
import InformationsCeaf from '../../../../../components/Ceaf/InformationCeaf/InformationsCeaf';
import RoutesMesTitresDeDetention from '../../../mes-titres-de-detention/routes';
import RoutesCeaf from '../routes';
import {
    INFOS_CEAF_PDF,
    MIME_APPLICATION_OCTET_STREAM,
    MIME_APPLICATION_PDF,
} from '../../../../../constants/fileConstant';
import { getPath } from '../../../../../utils/router';
import { CEAF } from '../../../../../constants/accessibilite.constants';

const VisualiserCeaf = ({
    getApi,
    erreur,
    reinitialiseApi,
    dataCeaf,
    isLoadingCeaf,
    dataCeafPdfBase64,
    isLoadingCeafPdfBase64,
}) => {
    const CLASSEMENT_EUROPEEN_C = 'C';
    const CLASSEMENT_ARME_NEUTRALISE = 'C 9°)';
    const { uuidCeaf } = useParams();
    const history = useHistory();
    const { photoIdentite, personnePhysique, armes, dateExpiration, numeroCeaf, statut, dateMaj } =
        dataCeaf || {};

    const [armeRecuperer, setArmeRecuperer] = useState([]);
    useEffect(() => {
        getApi(usagerClientReducer, API_CEAF_VISUALISER + uuidCeaf, CONTEXT_API_CEAF_VISUALISER);
        reinitialiseApi(CONTEXT_CEAF_GENERATION_PDF);

        return () => {
            reinitialiseApi(CONTEXT_API_CEAF_VISUALISER);
            reinitialiseApi(CONTEXT_CEAF_GENERATION_PDF);
        };
    }, []);

    if (erreur) {
        history.push(getPath(RoutesMesTitresDeDetention));
    }

    const classCssTitre = () => {
        let titreClassName = styles.containerInformations__titre;
        if (dataCeaf && statut === 'Expirée') {
            titreClassName += ` ${styles.containerInformations__titreAlerte}`;
        }

        return titreClassName;
    };

    const texteTitre = () => {
        if (dataCeaf && statut === 'Expirée') {
            return (
                <>
                    <abbr>{CEAF}</abbr> expirée depuis le {getDateFRFromYYYYMMDDHHMMSS(dateMaj)}
                </>
            );
        }

        return (
            <>
                <abbr>{CEAF}</abbr> valable jusqu'au {getDateFRFromYYYYMMDDHHMMSS(dateExpiration)}
            </>
        );
    };

    const titres = [
        "Numéro d'encodage",
        'Numéro de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre Canon 1',
        'Calibre Canon 2',
        'Classement',
        'Classement UE',
    ];

    useEffect(() => {
        if (dataCeaf !== null && Array.isArray(Object.values(armes))) {
            const liste = [];

            armes.forEach((arme) => {
                const { numEncodage, numeroCarcasse, classementEffectif } = arme;
                const { type, marque, modele, canonUn, classementEuropeen, canonDeux } =
                    arme.gdrRga;
                const classementUE =
                    classementEffectif === CLASSEMENT_ARME_NEUTRALISE
                        ? CLASSEMENT_EUROPEEN_C
                        : classementEuropeen;

                liste.push([
                    numEncodage,
                    numeroCarcasse,
                    type,
                    marque,
                    modele,
                    canonUn.libelleCalibre,
                    canonDeux ? canonDeux.libelleCalibre : ' - ',
                    classementEffectif,
                    classementUE,
                ]);
            });

            setArmeRecuperer(liste);
        }
    }, [dataCeaf]);

    const retourEcranTitreDetention = () => {
        history.push(getPath(RoutesMesTitresDeDetention));
    };

    const genererPdfCeaf = () => {
        if (dataCeaf) {
            getApi(
                usagerClientReducer,
                API_CEAF_GENERATION_PDF + uuidCeaf,
                CONTEXT_CEAF_GENERATION_PDF,
            );
        }
    };

    const editerCeaf = () => {
        history.push(getPath(RoutesCeaf.subroutes.editer));
    };

    return (
        <div className={styles.containerInformations}>
            {isLoadingCeaf && (
                <div className={styles.containerInformations__containerLoader}>
                    <LoaderMi taille="md" />
                </div>
            )}
            {dataCeaf && (
                <>
                    <h1>Carte Européenne d&apos;Armes à Feu n° {numeroCeaf}</h1>
                    <h2 className={classCssTitre()}> {texteTitre()} </h2>
                    <Row gutters isHorizontal className={styles.groupe_cartes}>
                        <Col col={12} lg={6} sm={12} className="margin-bottom-sm">
                            <VisualiserPhotoIdentite
                                photoIdentite={photoIdentite}
                                titre="Photo d'identité"
                            />
                        </Col>
                        <Col col={12} lg={6} sm={12} className="margin-bottom-sm">
                            <InformationsPersonnelles
                                personnePhysique={personnePhysique}
                                titre="Identité"
                            />
                        </Col>
                        <Col col={12} lg={6} sm={12} className="margin-bottom-sm">
                            <InformationAdresse
                                adresse={personnePhysique.adressePrincipale}
                                titre="Résidence principale"
                            />
                        </Col>
                        <Col col={12} lg={6} sm={12} className="margin-bottom-sm">
                            <InformationsCeaf informationsCeaf={dataCeaf} />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12}>
                            <h2 className="font-size-md margin0">
                                Armes que vous souhaitez voir apparaître sur votre carte européenne
                                d&apos;armes à feu
                            </h2>
                            <SimpleTable entete={titres} donnees={armeRecuperer} />
                        </Col>
                        <div className={styles.containerInformations__boutonsAction}>
                            <div className={styles.containerInformations__boutonsAction_alignRight}>
                                <BoutonFichierTelechargeable
                                    handleOnClick={genererPdfCeaf}
                                    label={
                                        <div>
                                            Télécharger ma <abbr>{CEAF}</abbr>
                                        </div>
                                    }
                                    title={`Télécharger ma ${CEAF}`}
                                    isLoading={isLoadingCeafPdfBase64}
                                    titreFichier={INFOS_CEAF_PDF}
                                    mimeType={MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM}
                                    contenu={dataCeafPdfBase64}
                                />
                                <Row className="margin-top-sm">
                                    <Col>
                                        <ButtonGroup align="right" inline>
                                            <Button
                                                variant="secondary"
                                                onClick={retourEcranTitreDetention}
                                                isLoading={isLoadingCeafPdfBase64}
                                            >
                                                Retour
                                            </Button>
                                            <Button
                                                variant="primary"
                                                onClick={editerCeaf}
                                                isLoading={isLoadingCeafPdfBase64}
                                            >
                                                <div>
                                                    Éditer ma carte européenne d'armes à feu (
                                                    <abbr>{CEAF}</abbr>)
                                                </div>
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Row>
                </>
            )}
        </div>
    );
};

VisualiserCeaf.propTypes = {
    reinitialiseApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    erreur: PropTypes.bool,
    dataCeafPdfBase64: PropTypes.object.isRequired,
    isLoadingCeafPdfBase64: PropTypes.bool.isRequired,
    dataCeaf: PropTypes.shape({
        photoIdentite: PropTypes.object.isRequired,
        statut: PropTypes.string.isRequired,
        dateExpiration: PropTypes.string.isRequired,
        numeroCeaf: PropTypes.string.isRequired,
        dateInit: PropTypes.string.isRequired,
        dateMaj: PropTypes.string.isRequired,
        expiree: PropTypes.bool.isRequired,
        personnePhysique: PropTypes.shape({
            nom: PropTypes.string.isRequired,
            nomUsage: PropTypes.string.isRequired,
            prenomUsuel: PropTypes.string.isRequired,
            prenomUn: PropTypes.string.isRequired,
            prenomDeux: PropTypes.string.isRequired,
            prenomTrois: PropTypes.string.isRequired,
            prenomQuatre: PropTypes.string.isRequired,
            sexe: PropTypes.string.isRequired,
            dateNaissance: PropTypes.string.isRequired,
            lieuNaissance: PropTypes.string.isRequired,
            codePostalNaissance: PropTypes.string.isRequired,
            paysNaissance: PropTypes.string.isRequired,
            nationalite: PropTypes.string.isRequired,
            adressePrincipale: PropTypes.shape({
                numeroVoie: PropTypes.string.isRequired,
                extension: PropTypes.string.isRequired,
                libelleVoie: PropTypes.string.isRequired,
                lieuDit: PropTypes.string.isRequired,
                codePostal: PropTypes.string.isRequired,
                ville: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        armes: PropTypes.arrayOf(
            PropTypes.shape({
                numeroEncodage: PropTypes.string.isRequired,
                numeroCarcasse: PropTypes.string.isRequired,
                gdrRga: PropTypes.shape({
                    type: PropTypes.string.isRequired,
                    marque: PropTypes.string.isRequired,
                    modele: PropTypes.string.isRequired,
                    canonUn: PropTypes.string.isRequired,
                    canonDeux: PropTypes.object.isRequired,
                    classementEuropeen: PropTypes.string.isRequired,
                }),
                neutralisee: PropTypes.bool.isRequired,
                classementEffectif: PropTypes.string.isRequired,
            }),
        ).isRequired,
    }).isRequired,
    isLoadingCeaf: PropTypes.bool.isRequired,
};

export default connect(
    (state) => {
        const { data: dataCeaf, erreur, isLoading: isLoadingCeaf } = state.ceaf.visualiser;

        const { data: dataCeafPdfBase64, isLoading: isLoadingCeafPdfBase64 } =
            state.ceaf.fichierPdfBase64;

        return {
            dataCeaf,
            erreur,
            isLoadingCeaf,
            dataCeafPdfBase64,
            isLoadingCeafPdfBase64,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(VisualiserCeaf);
